var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"SchoolPeople"},[_c('div',{staticClass:"img"},[_c('PreviewImage',{attrs:{"src":_vm.src}})],1),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }